export default __webpack_public_path__ + "static/media/bell.2b0a0d91.wav";